import { v4 as uuidv4 } from "uuid";
import ZonePointType from "../../../enums/robot/rooms/zone-point-type";
import IdTypePoint from "./id-type-point";
import { TeachAndRepeatResolveType } from "../../../enums/robot/rooms/teach-and-repeat-resolve-type";

const INHERIT = "Inherit";
type INHERIT_TYPE = typeof INHERIT;

interface TeachAndRepeatZonePath {
  id: string;
  roomId: string;
  zoneId: string;
  allowedDeviation: number | null;
  resolveConfiguration: TeachAndRepeatResolveType | null;
  path: PathPoint[];
}

export interface TeachAndRepeatZonePathApi{
  id: string;
  roomId: string;
  zoneId: string;
  allowedDeviation: number | null;
  resolveConfiguration: TeachAndRepeatResolveType | INHERIT_TYPE;
  path: number[][]
}

export const mapTeachAndRepeatZonePathApiToTeachAndRepeatZonePath = (apiData: TeachAndRepeatZonePathApi) =>
({
  ...apiData,
  id: apiData.id != null ? apiData.id : uuidv4(), // webapp doesn't provide an id so we give it one
  resolveConfiguration: (apiData.resolveConfiguration === INHERIT ? null : apiData.resolveConfiguration),
  path: mapApiPointsToPathPoints(apiData.path, ZonePointType.TeachAndRepeatZonePathPoint),
} as TeachAndRepeatZonePath);

export const mapPartialTeachAndRepeatZonePathApiToTeachAndRepeatZonePath = (apiData: Partial<TeachAndRepeatZonePathApi>) => ({
  ...apiData,
  resolveConfiguration: 
    apiData.resolveConfiguration !== undefined ?
    (apiData.resolveConfiguration === INHERIT ? null : apiData.resolveConfiguration)
    : undefined,
  path: apiData.path !== undefined ? mapApiPointsToPathPoints(apiData.path, ZonePointType.TeachAndRepeatZonePathPoint) : undefined,
  
} as Partial<TeachAndRepeatZonePath>);

export const mapPartialTeachAndRepeatZonePathToApi = (trZonePath: Partial<TeachAndRepeatZonePath>) =>({

    ...trZonePath,
    resolveConfiguration: trZonePath.resolveConfiguration !== undefined ? (trZonePath.resolveConfiguration ?? INHERIT) : undefined,
    path: trZonePath.path !== undefined ? mapPathPointsToApi(trZonePath.path) : undefined,

} as Partial<TeachAndRepeatZonePathApi>);

export interface PathPoint extends IdTypePoint {
  closeToObstacle: number;
}

export const mapApiPointsToPathPoints = (apiData: number[][], type: ZonePointType) => {
  const points: PathPoint[] = [];

  apiData.forEach((point) => {
    if (point.length === 4)
      points.push({
        coordinateX: point[0],
        coordinateY: point[1],
        coordinateTheta: point[2],
        closeToObstacle: point[3],
        id: points.length.toString(),
        type,
      });
  });

  return points;
};

export const mapPathPointsToApi = (points: PathPoint[]) =>
  points.map((p) => [p.coordinateX, p.coordinateY, p.coordinateTheta ?? 0, p.closeToObstacle]);


export const mapTeachAndRepeatZonePathToApi = (trZonePath: TeachAndRepeatZonePath) =>(
  {
    ...trZonePath,
    zoneId: trZonePath.zoneId,
    allowedDeviation: trZonePath.allowedDeviation,
    resolveConfiguration: trZonePath.resolveConfiguration ?? "Inherit",
    path: trZonePath.path.map((p) => [p.coordinateX, p.coordinateY, p.coordinateTheta ?? 0, p.closeToObstacle]),

  } as TeachAndRepeatZonePathApi
);

export const newTeachAndRepeatZonePath = (zoneId:string, roomId:string) : TeachAndRepeatZonePath => {
  return{
    id: uuidv4(),
    roomId: roomId,
    zoneId: zoneId,
    allowedDeviation: null,
    resolveConfiguration: null,
    path: [],
  };
};

export const isTeachAndRepeatZonePathObject = (payload: unknown): payload is TeachAndRepeatZonePath => {
  return (
    payload != null &&
    typeof payload === "object" &&
    "id" in payload &&
    "roomId" in payload &&
    "zoneId" in payload &&
    "allowedDeviation" in payload &&
    "resolveConfiguration" in payload &&
    "path" in payload
  );
}

export default TeachAndRepeatZonePath;